import { useContext, useEffect, useState } from 'react';
import useFetchData from '../../../hooks/useFetchData';
import Button from '../../Button';
import usePostData from '../../../hooks/usePostData';
import PropTypes from 'prop-types';

import './../style.scss';
import GlobalContext from 'contexts';

function UpdatingBloodTests({
  clientProductId,
  clientProductUuid,
  handleChangeMode
}) {
  const { currentCustomer, currentUser } = useContext(GlobalContext);
  const { data: bloodData, loading } = useFetchData(
    `blood-result-header/findOne/${clientProductUuid}/${currentCustomer?.gender}`
  );
  const { postData, res, error } = usePostData();
  const [bloodList, setBloodList] = useState([]);

  useEffect(() => {
    if (bloodData?.length) {
      setBloodList(bloodData);
    }
  }, [bloodData]);

  const onChangeHandler = (e, index, item) => {
    let value = 0;
    if (!e.target.value) value = -1;
    else value = Number(e.target.value);

    let newList = [...bloodList];

    const currentIndex = newList.findIndex(
      (existItem) => existItem.bloodParamId === item.bloodParamId
    );
    if (currentIndex > -1) {
      if (value === -1) newList[currentIndex].invalid = false;
      else if (value < item.minB1Value || value > item.maxB3Value)
        newList[currentIndex].invalid = true;
      else newList[currentIndex].invalid = false;
      newList[currentIndex].value = value;
      setBloodList(newList);
    }
  };

  useEffect(() => {
    if (error) console.log('error: ', error);
    else if (res) handleChangeMode(null);
  }, [res, error]);

  const onSubmit = () => {
    const ObjectToUpdating = {
      reporterId: currentUser.id,
      clientProductId,
      arr: bloodList
    };
    postData(`blood-result/CreateAllBloodResult`, ObjectToUpdating, 'post');
  };

  return (
    <div className="updatingBloodTests">
      <div className="list">
        {loading || !bloodList.length ? (
          <>Loading..</>
        ) : (
          bloodList.map((item, index) => (
            <div key={index} className="labInpGroup">
              <label>{item.name}</label>
              <input
                className={`${item.invalid ? 'invalid' : ''}`}
                onChange={(e) => onChangeHandler(e, index, item)}
                value={item?.value && item.value > -1 ? item.value : null}
                type="number"
                step="0.01"
                min={item.minB1Value}
                max={item.maxB3Value}
              />
            </div>
          ))
        )}
      </div>
      <div className="BtnSection">
        <Button
          handleClick={onSubmit}
          txt="שמור בדיקות"
          className="saveBtn"
          disable={bloodData?.findIndex((b) => b.invalid === true) > -1}
        />
      </div>
    </div>
  );
}

export default UpdatingBloodTests;

UpdatingBloodTests.propTypes = {
  clientProductId: PropTypes.string,
  clientProductUuid: PropTypes.string,
  handleChangeMode: PropTypes.func
};
